import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogBase } from 't4core';

@Component({
    selector: 't4-CallDialog',
    templateUrl: 'CallDialog.html',
})
export class CallDialog extends DialogBase implements OnInit {
    public rentalId: number;
    public receiver: string;
    public message: string;

    public calling: boolean = false;

    constructor(public dialogRef: MatDialogRef<CallDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        super("CallDialog");

        if (!data.rentalId) {
            alert("Rental id is missing");
            dialogRef.close();
        }

            this.rentalId = data.rentalId;
        if (data.receiver) this.receiver = data.receiver;
    }

    ngOnInit(): void {
        this.placeCall();
    }

    public saveNotes() {
        this.calling = true;
        this.Api.post("Rental/RentalEvent?rentalId=" + this.rentalId + "&type=501&message=" + this.message).then(x => {
            this.dialogRef.close();
            this.calling = false;
        });
    }

    public placeCall() {
        this.calling = true;
        this.Api.post("Messaging/PlaceCall?rentalId=" + this.rentalId).then(x => {
            alert(x);
            this.calling = false;
        });
    }
}
